import React, { useState, useEffect, useRef } from "react";
import { FaGithub, FaExternalLinkAlt, FaTimes } from "react-icons/fa";
import { projects } from "../../data/portfolioData";
import "./Projects.css";

const Projects = () => {
  const [filter, setFilter] = useState("all");
  const [selectedProject, setSelectedProject] = useState(null);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const filtered =
    filter === "all"
      ? projects
      : filter === "featured"
      ? projects.filter((p) => p.featured)
      : projects;

  return (
    <section className="projects" id="projects" ref={sectionRef}>
      <div className="projects__container">
        <h2 className="section-title">My Projects</h2>
        <p className="section-subtitle">Things I've built</p>

        {/* Filters */}
        <div className="projects__filters">
          {["all", "featured"].map((f) => (
            <button
              key={f}
              className={`projects__filter ${filter === f ? "projects__filter--active" : ""}`}
              onClick={() => setFilter(f)}
            >
              {f === "all" ? "All Projects" : "Featured"}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="projects__grid">
          {filtered.map((project, idx) => (
            <div
              key={project.id}
              className={`project-card ${visible ? "animate-fade-up" : ""}`}
              style={{ animationDelay: `${idx * 0.12}s` }}
              onClick={() => setSelectedProject(project)}
            >
              <div className="project-card__image-wrapper">
                <img
                  src={project.image}
                  alt={project.title}
                  className="project-card__image"
                  loading="lazy"
                />
                <div className="project-card__overlay">
                  <span>View Details</span>
                </div>
              </div>
              <div className="project-card__body">
                <h3 className="project-card__title">{project.title}</h3>
                <p className="project-card__desc">
                  {project.description.substring(0, 100)}...
                </p>
                <div className="project-card__tech">
                  {project.techStack.map((tech) => (
                    <span key={tech} className="tech-tag">
                      {tech}
                    </span>
                  ))}
                </div>
                <div className="project-card__links">
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    aria-label="GitHub"
                  >
                    <FaGithub />
                  </a>
                  <a
                    href={project.liveDemo}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    aria-label="Live Demo"
                  >
                    <FaExternalLinkAlt />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Modal ── */}
      {selectedProject && (
        <div className="modal-backdrop" onClick={() => setSelectedProject(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal__close"
              onClick={() => setSelectedProject(null)}
            >
              <FaTimes />
            </button>
            <img
              src={selectedProject.image}
              alt={selectedProject.title}
              className="modal__image"
            />
            <div className="modal__body">
              <h3>{selectedProject.title}</h3>
              <p>{selectedProject.description}</p>
              <div className="project-card__tech">
                {selectedProject.techStack.map((tech) => (
                  <span key={tech} className="tech-tag">
                    {tech}
                  </span>
                ))}
              </div>
              <div className="modal__links">
                <a
                  href={selectedProject.github}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn--primary"
                >
                  <FaGithub /> GitHub
                </a>
                <a
                  href={selectedProject.liveDemo}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn--outline"
                >
                  <FaExternalLinkAlt /> Live Demo
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Projects;
